import React from 'react';
import { cn } from '@/lib/utils';

const CandidatesTablePaper = ({
    children,
    className,
    ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement> & { className?: string }>) => {
    return (
        <div className={cn('bg-background flex flex-col overflow-auto rounded-t-none', className)} {...props}>
            {children}
        </div>
    );
};

export default CandidatesTablePaper;
